import { useState, useCallback } from 'react';

export const useClipboard = () => {
  const [clipboardSupported, setClipboardSupported] = useState(false);

  // Check clipboard support on mount
  useState(() => {
    setClipboardSupported(!!navigator.clipboard);
  });

  const copyToClipboard = useCallback(async (text) => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        return { success: true, message: 'Copied to clipboard!' };
      } else {
        // Fallback for older browsers
        return fallbackCopyTextToClipboard(text);
      }
    } catch (error) {
      console.error('Clipboard API failed:', error);
      return fallbackCopyTextToClipboard(text);
    }
  }, []);

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      document.body.removeChild(textArea);
      return { success: true, message: 'Copied to clipboard!' };
    } catch (err) {
      document.body.removeChild(textArea);
      return { success: false, message: 'Failed to copy to clipboard' };
    }
  };

  return {
    clipboardSupported,
    copyToClipboard
  };
};
